import { apiAgent } from "./axiosConfig"
import getApiUrl from "./components/utils/UrlHelper"

export const logoutApi = () => {
    return apiAgent({
        method: "post",
        url: getApiUrl('logout'),
        data: {}
    })
}